import { render, staticRenderFns } from "./IngredientsView.vue?vue&type=template&id=487132d8&scoped=true"
import script from "./IngredientsView.vue?vue&type=script&lang=js"
export * from "./IngredientsView.vue?vue&type=script&lang=js"
import style0 from "./IngredientsView.vue?vue&type=style&index=0&id=487132d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487132d8",
  null
  
)

export default component.exports